import { render, staticRenderFns } from "./ActionAttachmentUpload.vue?vue&type=template&id=494a223c&"
import script from "./ActionAttachmentUpload.vue?vue&type=script&lang=js&"
export * from "./ActionAttachmentUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports